import { combineReducers } from "redux";
import { Actions, StoreState } from '../types';
import { getType } from "typesafe-actions";
import * as actions from '../actions';
import { HidDevice } from "../../model";

function secondaryRingerDeviceId(state: string = '', action: Actions): string {
    switch (action.type) {
        case getType(actions.configureSecondaryRinger):
            return action.payload
    }
    return state;
}

function hidDevices(state: HidDevice[] = [], action: Actions): HidDevice[] {
    switch (action.type) {
        case getType(actions.setWebHidDeviceList):
            return action.payload
    }
    return state;
}

function selectedJabraDevice(state: {deviceName: string, deviceId: string} | null = null, action: Actions) {
    switch (action.type) {
        case getType(actions.setSelectedJabraDevice):
            return action.payload
    }
    return state;
}

export default combineReducers({
    secondaryRingerDeviceId,
    hidDevices,
    selectedJabraDevice,
})

export function selectSecondaryRingerDeviceId(state: StoreState) {
    return state.janus.devices.secondaryRingerDeviceId
  }
  